export const state = () => ({
  users: [],
  currentUser: null,
  loading: false,
  error: null,
  pagination: {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0
  }
})

export const getters = {
  users: (state) => state.users,
  currentUser: (state) => state.currentUser,
  loading: (state) => state.loading,
  error: (state) => state.error,
  pagination: (state) => state.pagination
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_USERS(state, data) {
    console.log('SET_USERS mutation called with:', data)
    console.log('Data type:', typeof data)
    console.log('Is array?', Array.isArray(data))
    console.log('Has content?', data?.content)
    console.log('Full data object keys:', data ? Object.keys(data) : 'null')
    
    // Handle Spring Data Page response
    if (data && data.content && Array.isArray(data.content)) {
      console.log('Setting users from content array, length:', data.content.length)
      // Use Vue.set or direct assignment for reactivity
      state.users = [...data.content] // Create new array for reactivity
      state.pagination = {
        page: data.number || 0,
        size: data.size || 10,
        totalElements: data.totalElements || 0,
        totalPages: data.totalPages || 0
      }
    } else if (Array.isArray(data)) {
      console.log('Setting users from direct array, length:', data.length)
      // Handle direct array response
      state.users = [...data] // Create new array for reactivity
    } else {
      console.log('No valid data structure, setting empty array')
      console.log('Data value:', JSON.stringify(data))
      // Fallback: empty array
      state.users = []
    }
    
    console.log('Final state.users length:', state.users.length)
    console.log('Final state.users:', state.users)
  },
  SET_CURRENT_USER(state, user) {
    state.currentUser = user
  },
  ADD_USER(state, user) {
    state.users.push(user)
  },
  UPDATE_USER(state, user) {
    const index = state.users.findIndex(u => u.id === user.id)
    if (index !== -1) {
      state.users.splice(index, 1, user)
    }
  },
  REMOVE_USER(state, userId) {
    state.users = state.users.filter(u => u.id !== userId)
  }
}

export const actions = {
  async fetchUsers({ commit, rootState }, { page = 0, size = 10, sortBy = 'username', direction = 'asc', schoolId = null } = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      let url = '/auth/api/user'
      const params = { page, size, sortBy, direction }
      
      // If schoolId is provided or user is not super admin, filter by school
      const currentUser = rootState.auth.user
      const userSchoolId = currentUser?.attributes?.school_id || currentUser?.school_id
      
      if (schoolId || (!rootState.auth.user?.attributes?.roles?.some(r => r.authority === 'SYSTEM_ADMIN') && userSchoolId)) {
        const targetSchoolId = schoolId || userSchoolId
        url = `/auth/api/user/by-school/${targetSchoolId}`
      }
      
      const response = await this.$axios.get(url, { params })
      // Debug: log the response structure
      console.log('API Response:', response.data)
      console.log('Response type:', typeof response.data)
      console.log('Has content?', response.data?.content)
      console.log('Is array?', Array.isArray(response.data))
      
      // Ensure we're committing the correct data structure
      commit('SET_USERS', response.data)
      
      // Debug: log after commit
      console.log('After commit, state.users should be set')
      
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch users')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchUser({ commit }, userId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get(`/auth/api/user/${userId}`)
      commit('SET_CURRENT_USER', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch user')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createUser({ commit }, userData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.post('/auth/api/user', userData)
      commit('ADD_USER', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to create user')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateUser({ commit }, { userId, userData }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.post(`/auth/api/user/${userId}`, userData)
      commit('UPDATE_USER', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to update user')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteUser({ commit }, userId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      await this.$axios.delete(`/auth/api/user/${userId}`)
      commit('REMOVE_USER', userId)
      return true
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to delete user')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

